import { render } from "./ZNxiangq.vue?vue&type=template&id=4c4cc9b7&scoped=true"
import script from "./ZNxiangq.vue?vue&type=script&lang=js"
export * from "./ZNxiangq.vue?vue&type=script&lang=js"

import "./ZNxiangq.vue?vue&type=style&index=0&id=4c4cc9b7&lang=scss&scoped=true"
import "./ZNxiangq.vue?vue&type=style&index=1&id=4c4cc9b7&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4cc9b7"]])

export default __exports__